var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrientationDocuments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "class_black_24dp",
    "data-name": "class black 24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M-2-2H22V22H-2Z",
    transform: "translate(2 2)",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Union_8",
    "data-name": "Union 8",
    d: "M2.91,19.6A1.34,1.34,0,0,1,1.6,18.29V4.78H2.91V18.29H13.78V19.6ZM5.53,17a1.34,1.34,0,0,1-1.31-1.31v-14A1.33,1.33,0,0,1,5.53.4h7.59l5.06,5.06V15.67A1.34,1.34,0,0,1,16.87,17Zm11.34-1.31V6h-4.4V1.71H5.53v14ZM7.6,13.6V12.4h7.2v1.2Zm0-3.6V8.8h7.2V10Z",
    transform: "translate(2 2)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrientationDocuments);
export default __webpack_public_path__ + "static/media/orientation_documents.bf1f838a679ed5b48bf0f5878ba2b153.svg";
export { ForwardRef as ReactComponent };